import { formatNumber } from "../../utils/functions/formatNumber";

/**
 *
 * @param {Object} params Object from the formatter function for a treemap tooltip
 * @returns HTML in string format with tooltip contents
 */
export function generateTreemapTooltip(params) {
  let arr = [
    params.treeAncestors.length === 3
      ? "<span>" +
        params.treeAncestors[1].name +
        " > " +
        params.name +
        "</span><br/>" +
        "<div> " +
        formatNumber(params.data.value.toFixed(1), params.lang) +
        "%" +
        "</div>"
      : "<span>" +
        params.name +
        "</span><br/>" +
        "<div>" +
        formatNumber(params.data.value.toFixed(1), params.lang) +
        "%" +
        "</div>",
  ];
  return arr.join("\n");
}
